import { BulkDrawerFormFieldsMap } from 'UI/components/organisms/BulkEmailForm/fields';

const attemptsKey = BulkDrawerFormFieldsMap.Attempts.key;

export const buildAttemptsFormKey = id => `${attemptsKey}${id}`;

export const getAttemptsFormKeys = ids => ids.map(buildAttemptsFormKey);

export const getAttemptsFormValues = watch => {
  const attemptsIds = watch(attemptsKey, []);

  const pathsToWatch = getAttemptsFormKeys(attemptsIds);
  return watch(pathsToWatch);
};
